/**
 * Drill from one cell of a correlation matrix into the pair it stands for.
 *
 * A coefficient only measures a straight line - a perfect horseshoe scores
 * about zero - so the matrix has to be able to hand you the pair itself. One
 * click switches to a scatter plot of those two signals and plots it.
 *
 * The matrix's own configuration is left untouched, so clicking Correlation in
 * the type grid brings the same signals, order and method straight back. The
 * Y series are not: scatter shares them with Line, so the drill replaces them
 * with the one signal of the pair.
 *
 * `doPlot` is imported lazily: this module is reached from the render layer, and
 * the action layer imports the render layer.
 */

import { addSeries, clearAllSeries, setPlotType, setXColumn } from '../../state/plot-state.ts';
import { showToast } from '../../ui/toast.ts';

export function drillIntoPair(x: string, y: string): void {
  setPlotType('scatter');
  setXColumn(x);
  clearAllSeries();
  addSeries('left', y);
  showToast('success', `${x} × ${y} as a scatter plot - Correlation keeps your signals.`);
  void import('./plot-actions.ts').then((m) => m.doPlot());
}
